module.exports = __webpack_public_path__ + "static/media/email.c5224b5c.svg";